import styled from 'styled-components'
import { Card as CardComp } from 'src/components/Ant'

export const Card = styled(CardComp)`
  margin-bottom: 16px;
`

export const Empty = styled.div`
  padding: 16px;
  color: rgba(0, 0, 0, 0.25);
  font-size: 14px;
  text-align: center;
`
